import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams  } from "react-router-dom";
import { getPacienteById } from "../../../../services/pacientes";
import { getHistoriaClinica,getConsultasHistoriaClinica,auditarExpedienteExportado, getCatalogoServiciosAtencion, getNombresDiagnosticos } from "../../../../services/historiaClinica";

import "./DashboardPaciente.css";
import ModalEditarPaciente from "../ModalesEdicion/ModalEditarPaciente";
import ModalEditarHistoria from "../ModalesEdicion/ModalEditarHistoria";
import ModalEditarConsulta from "../ModalesEdicion/ModalEditarConsulta";
import ModalImpresionExpediente from "../ModalesEdicion/ModalImpresionExpediente";
import { obtenerRecetasPorPaciente } from "../../../../services/recetas";
import RecetaLista from "../../Recetas electronicas/RecetaLista";
import { mapBackendToFrontend } from "../../../../services/variableMapper";
import api from "../../../../services/config";
import { getPresignedGetUrlHistoria, getPresignedGetUrlConsulta, openPresignedUrl } from "../../../../services/labsS3";
import ResumenPaciente from "./ResumenPaciente";
import DatosPaciente from "./DatosPaciente";
import InterrogatorioPaciente from "./InterrogatorioPaciente";
import ExploracionFisicaPaciente from "./ExploracionFisicaPaciente";
import ConsultasPaciente from "./ConsultasPaciente";
import EstudiosPaciente from "./EstudiosPaciente";
import RecetasPaciente from "./RecetasPaciente";
import { generarExpedientePDF } from "../../../../pdf/expedientePDF";
import { getMedicoAuth } from "../../../../services/usuarios";
import { obtenerConfiguracionReceta } from "../../../../services/recetas"; //imagen de las recetas primero la traes NO LA PINTAS
import { obtenerEstadoSuscripcion } from "../../../../services/pagos"; //export necesitas suscripcion
import {getCatalogoPais,getCatalogoEntidades,getCatalogoMunicipios,getCatalogoLocalidades,} from "../../../../services/usuarios";

const BASE_API_URL = process.env.REACT_APP_BACKEND_URL;

const DashboardPaciente = () => {
  const { id: pacienteId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarModalHistoria, setMostrarModalHistoria] = useState(false);
  const [mostrarModalConsulta, setMostrarModalConsulta] = useState(false);
  const [paciente, setPaciente] = useState(null);
  const [historiaClinica, setHistoriaClinica] = useState(null);
  const [mostrarModalImpresion, setMostrarModalImpresion] = useState(false);
  const [consultaSeleccionada, setConsultaSeleccionada] = useState(null);
  const [expandedSections, setExpandedSections] = useState({resumen: false,
    consultas: false,
    historia: false,
    signosvitales: false,
    recetas: false,});
  const [recetas, setRecetas] = useState([]);
  //NUEVOS!!!
  const [activeTab, setActiveTab] = useState("resumen");
  const [, setConsultas] = useState([]);
  // ID del expediente que estamos viendo. Default: el del URL (destino).
  // Cambia cuando el doctor selecciona "Previo a fusión..." en el dropdown.
  const [expedienteActivoId, setExpedienteActivoId] = useState(pacienteId);
  // Si cambia el pacienteId del URL (navegación a otro expediente),
  // resetear el selector al destino actual.
  // Lista de orígenes fusionados con el destino. Se guarda la primera vez
  // que se carga el destino y no cambia al hacer switch en el dropdown.
  const [fusionadosDelDestino, setFusionadosDelDestino] = useState([]);
  // Datos del paciente destino (URL). Se guarda una vez y NO cambia
 // al hacer switch en el dropdown. El header SIEMPRE lee de aquí.
 const [pacienteDestino, setPacienteDestino] = useState(null);
  const formatFechaCorta = (iso) => {
    if (!iso) return "—";
    try {
      return new Date(iso).toLocaleDateString("es-MX");
    } catch {
      return "—";
    }
  };

  const enVistaPrevia = expedienteActivoId !== pacienteId;
  const origenActivo = fusionadosDelDestino.find((o) => o.id === expedienteActivoId);




  useEffect(() => {
    setExpedienteActivoId(pacienteId);
  }, [pacienteId]);

  
   useEffect(() => {
  if (searchParams.get("editar") === "true" && paciente) {
    setMostrarModal(true);
    // Limpiar el param para que no reabra al recargar datos
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("editar");
    navigate(`?${newParams.toString()}`, { replace: true });
  }
}, [paciente, searchParams]);

    useEffect(() => {
      fetchData();
   }, [expedienteActivoId]);

    const fetchData = async () => {
      try {
        const pacienteEncontrado = await getPacienteById(expedienteActivoId);
        setPaciente(pacienteEncontrado);

       // Solo guardar fusionados y destino cuando estamos en el destino (URL = expediente activo)
        if (expedienteActivoId === pacienteId) {
          setFusionadosDelDestino(pacienteEncontrado?.pacientes_fusionados || []);
         setPacienteDestino(pacienteEncontrado);
        }
  
        if (pacienteEncontrado) {
          const historia = await getHistoriaClinica(pacienteEncontrado.id);
  
          if (historia?.id) {
            // 🔹 Obtener y mapear consultas
            const consultasData = await getConsultasHistoriaClinica(historia.id);
            
            const consultasConvertidas = Array.isArray(consultasData)
              ? consultasData.map(mapBackendToFrontend)
              : [];
  
            // 🔹 Obtener y setear recetas
            const recetasData = await obtenerRecetasPorPaciente(pacienteEncontrado.id);
            setRecetas(recetasData); // <<--- AQUÍ SE CARGAN LAS RECETAS
  
            // 🔹 Mapear historia clínica + consultas
            const historiaConvertida = mapBackendToFrontend(historia);
            historiaConvertida.consultas = consultasConvertidas;
  
            setHistoriaClinica(historiaConvertida);
            setConsultas(consultasConvertidas);
  
           
          }
        }
      } catch (error) {
        console.error("Error cargando datos del paciente:", error);
      }
    };

    //Eliminar Laboratorio de la historia con condicional

      const handleDeleteLaboratorioHistoria = async (historiaId, lab) => {
    if (
      !window.confirm(
        '¿Seguro que deseas eliminar este archivo del expediente clínico? Esta acción no se puede deshacer.'
      )
    ) {
      return;
    }

    try {
      if (lab.key) {
          // 🟢 Nuevo flujo S3 (labs nuevos)
          await api.post(
            `/historias-clinicas/${historiaId}/labs/delete/`,
            { lab_id: lab.id }
          );
        } else {

        // 🟠 Flujo legacy (MEDIA, por nombre)
        await api.delete(`/historias-clinicas/${historiaId}/delete_laboratorio/`, {
          params: { archivo: lab.nombre },
        });
      }

      alert("Archivo eliminado correctamente");
      fetchData(); // recargas la data
    } catch (error) {
      console.error("Error al eliminar laboratorio de historia clínica:", error);
      alert("Error eliminando archivo");
    }
  };

    
    //Eliminar Laboratorio de la consulta
  const handleDeleteLaboratorioConsulta = async (consultaId, lab) => {
    if (
      !window.confirm(
        '¿Seguro que deseas eliminar este archivo del expediente clínico? Esta acción no se puede deshacer.'
      )
    ) {
      return;
    }

    try {
      if (lab.key) {
          // 🟢 Nuevo flujo S3 (labs nuevos en consulta)
          await api.post(
            `/historias-clinicas/${historiaClinica.id}/consultas/${consultaId}/labs/delete/`,
            { lab_id: lab.id }
          );
        } else {
        // 🟠 Flujo legacy (MEDIA, por nombre)
        await api.delete(`/consultas/${consultaId}/delete_laboratorio/`, {
          params: { archivo: lab.nombre },
        });
      }

      alert("Archivo eliminado correctamente");
      fetchData(); // recargas la data
    } catch (error) {
      console.error("Error al eliminar laboratorio de consulta:", error);
      alert("Error eliminando archivo");
    }
  };

  const handleDobleClickReceta = (receta) => {
    navigate("/dashboard/recetas/formulario", { state: { receta } });
  };

  
  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section], // Alterna el estado de la sección específica
    }));
  };

  const toggleModal = () => {
    setMostrarModal(!mostrarModal);
  };

  const toggleModalHistoria = () => {
    setMostrarModalHistoria(!mostrarModalHistoria); 
  };

  const toggleModalConsulta = () => {
    setMostrarModalConsulta(!mostrarModalConsulta);
  };
  
  //nos traemos al medico y la imagen de la receta solo para impresion..
  const [medico, setMedico] = useState(null);
  const [configReceta, setConfigReceta] = useState(null);
      useEffect(() => {
      const fetchMedico = async () => {
        const data = await getMedicoAuth();
        setMedico(data);
      };

      fetchMedico();
    }, []);

        useEffect(() => {
      const fetchConfigReceta = async () => {
          const data = await obtenerConfiguracionReceta();
          setConfigReceta(data);
      };
    

      fetchConfigReceta();
    }, []);

  const handleImprimirExpediente = async (consulta = null) => {
     // 🔒 Validar suscripción antes de exportar expediente
     //temporalmente apagado TEMPORAL
  //try {
  //  const data = await obtenerEstadoSuscripcion();
  //  const status = data?.status;

  //  if (!["active", "trialing"].includes(status)) {
  //    alert("Tu suscripción no está activa. Por favor, actualiza tu plan para continuar.");
  //    return;
  //  }
  //} catch (error) {
  //  alert("No se pudo validar tu suscripción. Intenta nuevamente.");
  //  return;
  //}


  let logoDoctorBase64 = null;
  const urlLogo = configReceta?.imagen_encabezado;

  if (urlLogo) {
    try {
      const response = await fetch(urlLogo, { credentials: "include" });
      const blob = await response.blob();

      logoDoctorBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      // Si falla, simplemente no se pinta el logo del doctor
      logoDoctorBase64 = null;
    }
  }
  
  // 🔹 Determinar qué consultas imprimir
  let consultasAImprimir = historiaClinica?.consultas || [];

 if (consulta) {
   consultasAImprimir = [consulta]; }
   
    // 🔹 Log exportación expediente
await auditarExpedienteExportado(
  paciente?.id || null,
  consulta ? consulta.id : null
);

// 🔹 Traducir códigos NOM/SIS a texto para PDF
let pacienteParaPDF = paciente;

try {
  const [paises, entidades] = await Promise.all([
    getCatalogoPais(),
    getCatalogoEntidades(),
  ]);

  let municipios = [];
  let localidades = [];

  if (String(paciente?.paisResidencia) === "142" && paciente?.entidadResidencia) {
    municipios = await getCatalogoMunicipios(
      String(paciente.entidadResidencia).padStart(2, "0")
    );

    if (paciente?.municipio) {
      localidades = await getCatalogoLocalidades(
        String(paciente.entidadResidencia).padStart(2, "0"),
        String(paciente.municipio).padStart(3, "0")
      );
    }
  }

  const textoPais = (clave) => {
    if (!clave) return "";
    const item = (paises || []).find(
      (p) => String(p.CATALOG_KEY) === String(clave)
    );
    return item?.DESCRIPCION || clave;
  };

  const textoEntidad = (clave) => {
    if (!clave) return "";
    const normalizada = String(clave).padStart(2, "0");
    const item = (entidades || []).find(
      (e) => String(e.CATALOG_KEY).padStart(2, "0") === normalizada
    );
    return item?.ENTIDAD_FEDERATIVA || clave;
  };

  const textoMunicipio = (clave) => {
    if (!clave) return "";
    const normalizada = String(clave).padStart(3, "0");
    const item = (municipios || []).find(
      (m) => String(m.CATALOG_KEY).padStart(3, "0") === normalizada
    );
    return item?.MUNICIPIO || clave;
  };

  const textoLocalidad = (clave) => {
    if (!clave) return "";
    const normalizada = String(clave).padStart(4, "0");
    const item = (localidades || []).find(
      (l) => String(l.CATALOG_KEY).padStart(4, "0") === normalizada
    );
    return item?.LOCALIDAD || clave;
  };

  pacienteParaPDF = {
    ...paciente,
    paisNacPaciente: textoPais(paciente?.paisNacPaciente),
    entidadNacimiento: textoEntidad(paciente?.entidadNacimiento),
    paisResidencia: textoPais(paciente?.paisResidencia),
    entidadResidencia: textoEntidad(paciente?.entidadResidencia),
    municipio: textoMunicipio(paciente?.municipio),
    localidad: textoLocalidad(paciente?.localidad),
  };
} catch (error) {
  console.error("Error traduciendo catálogos para PDF:", error);
  pacienteParaPDF = paciente; // fallback: exporta con códigos si falla catálogo
}

  // 🔹 Nombres de servicio de atención y diagnósticos CIE para el PDF
  let catalogosPDF = { servicios: {}, nombresCIE: {} };

  try {
    const registros = [
      historiaClinica,
      ...(Array.isArray(historiaClinica?.consultas) ? historiaClinica.consultas : []),
    ].filter(Boolean);

    const clavesCIE = registros.flatMap((r) => [
      r?.codigoCIEDiagnostico1,
      r?.codigoCIEDiagnostico2,
      r?.codigoCIEDiagnostico3,
    ]);

    const [listaServicios, nombresCIE] = await Promise.all([
      getCatalogoServiciosAtencion(),
      getNombresDiagnosticos(clavesCIE),
    ]);

    const servicios = {};
    (listaServicios || []).forEach((s) => {
      servicios[String(s.CATALOG_KEY)] = s.SERVICIOS_ATENCION;
    });

    catalogosPDF = { servicios, nombresCIE: nombresCIE || {} };
  } catch (error) {
    console.error("Error cargando catálogos para PDF:", error);
    // Si falla, el PDF sale igual, solo con las claves en lugar de los nombres
  }

  generarExpedientePDF({
    paciente: pacienteParaPDF,
    direccion: paciente?.direccion || null,
    medico,
    historiaClinica,
    
    consultas: consultasAImprimir,
    soloConsulta: !!consulta,
    logoDoctorBase64, // ← ya va listo para el engine
    catalogos: catalogosPDF,
  });
};

const fechaActivacionNomRaw = medico?.perfil?.nom024_activado_en;

const fechaActivacionNom = fechaActivacionNomRaw
  ? new Date(fechaActivacionNomRaw)
  : null;

const fechaCreacionHistoriaRaw =
  historiaClinica?.fechaCreacion ||
  historiaClinica?.fecha_creacion;

const historiaPosteriorActivacion =
  fechaActivacionNom &&
  fechaCreacionHistoriaRaw &&
  new Date(fechaCreacionHistoriaRaw) > fechaActivacionNom;

const consultaPosteriorActivacion =
  fechaActivacionNom &&
  Array.isArray(historiaClinica?.consultas) &&
  historiaClinica.consultas.some((consulta) => {
    const fechaCreacionConsultaRaw =
      consulta?.fechaCreacion ||
      consulta?.fecha_creacion ||
      consulta?.creadoEn ||
      consulta?.creado_en;

    return (
      fechaCreacionConsultaRaw &&
      new Date(fechaCreacionConsultaRaw) > fechaActivacionNom
    );
  });

const tieneAtencionDesdeActivacionNom =
  Boolean(historiaPosteriorActivacion || consultaPosteriorActivacion);
  
  return (

 <div className="dashboard-paciente-nuevo">
  
  
   {/* ===============================
       HEADER STICKY DEL PACIENTE
       =============================== */}
   <header className="paciente-header-sticky">
     <div className="paciente-avatar">
       <div className="paciente-avatar-placeholder">
       {pacienteDestino?.nombre?.charAt(0) || "?"}
       </div>
     </div>
     

     <div className="paciente-header-info">
       <div className="paciente-nombre">
         {pacienteDestino
          ? [pacienteDestino.nombre, pacienteDestino.apellido_paterno, pacienteDestino.apellido_materno]
               .filter(Boolean)
               .join(" ")
           : "—"}
       </div>

       <div className="paciente-datos-clave">
         Edad: {pacienteDestino?.edad ?? "—"} años ·{" "}
        Sexo: {pacienteDestino?.sexo || "—"} ·{" "}
        Teléfono: {pacienteDestino?.telefono || "—"} ·{" "}
        Correo: {pacienteDestino?.correo || "—"}
       </div>

       <div className="paciente-metadata">
        ID Salvir: {pacienteDestino?.id ? pacienteDestino.id.slice(-5).toUpperCase() : "—"}
          {" · "}
          {historiaClinica
            ? 1 + (Array.isArray(historiaClinica.consultas) ? historiaClinica.consultas.length : 0)
            : 0}{" "}
          Consultas totales · Última consulta:{" "}        {(() => {
          if (!historiaClinica) return "—";

          const inicialFecha = historiaClinica.fechaConsulta;
          const seguimientos = Array.isArray(historiaClinica.consultas)
            ? historiaClinica.consultas
            : [];

          if (!seguimientos.length) {
            return inicialFecha
              ? new Date(inicialFecha).toLocaleDateString("es-MX")
              : "—";
          }

          const ultimaSeguimiento = [...seguimientos].sort(
            (a, b) => new Date(b.fechaConsulta) - new Date(a.fechaConsulta)
          )[0];

          const fechaFinal =
            inicialFecha &&
            new Date(inicialFecha) > new Date(ultimaSeguimiento.fechaConsulta)
              ? inicialFecha
              : ultimaSeguimiento.fechaConsulta;

          return fechaFinal
            ? new Date(fechaFinal).toLocaleDateString("es-MX")
            : "—";
        })()}{" "}
        · Paciente desde:{" "}
        {pacienteDestino?.fecha_registro || pacienteDestino?.fecha_creacion || pacienteDestino?.creado_en
        ? new Date(
            pacienteDestino.fecha_registro || pacienteDestino.fecha_creacion || pacienteDestino.creado_en
          ).toLocaleDateString("es-MX")
        : "—"}
       </div>
           {fusionadosDelDestino.length > 0 && (
      <select
        className="button-imprimir"
        value={expedienteActivoId}
        onChange={(e) => setExpedienteActivoId(e.target.value)}
        style={{ marginRight: "8px" }}
      >
        <option value={pacienteId}>Actual</option>
        {fusionadosDelDestino.map((o) => (
          <option key={o.id} value={o.id}>
            Previo a fusión {formatFechaCorta(o.fecha_actualizacion)}
          </option>
        ))}
      </select>
    )}
    <button className="button-imprimir" onClick={() => setMostrarModalImpresion(true)}>
      Exportar expediente
     </button>
     </div>
     
     <button className="button-atras" onClick={() => navigate("/dashboard/historias-clinicas")}>
        ← Volver
        </button>
   </header>

   {/* ===============================
       NAV STICKY (SIN FUNCIONALIDAD)
       =============================== */}
   <nav className="paciente-nav-sticky">
     <div className="paciente-nav-tabs">
       <div className={`paciente-nav-tab ${activeTab === "resumen" ? "active" : ""}`} onClick={() => setActiveTab("resumen")}>
        Resumen
       </div>
       <div className={`paciente-nav-tab ${activeTab === "datos" ? "active" : ""}`} onClick={() => setActiveTab("datos")}>
        Ficha de identificación
       </div>
       <div className={`paciente-nav-tab ${activeTab === "interrogatorio" ? "active" : ""}`} onClick={() => setActiveTab("interrogatorio")}>
       Interrogatorio
       </div>
       <div className={`paciente-nav-tab ${activeTab === "signos" ? "active" : ""}`} onClick={() => setActiveTab("signos")}>
       Signos vitales
       </div>
       <div className={`paciente-nav-tab ${activeTab === "estudios" ? "active" : ""}`} onClick={() => setActiveTab("estudios")}>
       Estudios
       </div>
       <div className={`paciente-nav-tab ${activeTab === "consultas" ? "active" : ""}`} onClick={() => setActiveTab("consultas")}>
       Consultas
       </div>
       <div className={`paciente-nav-tab ${activeTab === "recetas" ? "active" : ""}`} onClick={() => setActiveTab("recetas")}>
       Recetas
       </div>
     </div>
   </nav>

   {/* ===============================
       CONTENEDOR VACÍO (PLACEHOLDER)
       =============================== */}
   <main className="paciente-contenido">
    {enVistaPrevia && (
      <div style={{
        background: "#fff7e0",
        border: "1px solid #f5c97a",
        color: "#7a5b00",
        padding: "10px 14px",
        borderRadius: "8px",
        marginBottom: "16px",
        fontSize: "0.9rem",
      }}>
        Estás viendo el expediente previo a la fusión del{" "}
        <strong>{formatFechaCorta(origenActivo?.fecha_actualizacion)}</strong>.
        {origenActivo && (
          <> Este paciente previamente se conocía como{" "}
            <strong>
              {[origenActivo.nombre, origenActivo.apellido_paterno, origenActivo.apellido_materno]
                .filter(Boolean)
                .join(" ")}
            </strong>.
          </>
        )}
        
      </div>
    )}
     {activeTab === "resumen" && (
      <ResumenPaciente
        paciente={paciente}
        historiaClinica={historiaClinica}
        recetas={recetas}
      />
      )}
      {activeTab === "datos" && (
        <DatosPaciente
          paciente={paciente}
          direccion={paciente?.direccion || null}
          onEditar={toggleModal}
          readOnly={enVistaPrevia}
        />
      )}
      {activeTab === "interrogatorio" && historiaClinica && (
        <InterrogatorioPaciente
          historiaClinica={historiaClinica}
          onEditar={toggleModalHistoria}
          readOnly={enVistaPrevia}
        />
      )}
     
      {activeTab === "signos" && (
        <ExploracionFisicaPaciente historiaClinica={historiaClinica} />
      )}
      {activeTab === "consultas" && (
        <ConsultasPaciente
          historiaClinica={historiaClinica}
        />
      )}
      {activeTab === "estudios" && (
        <EstudiosPaciente
          historiaClinica={historiaClinica}
           readOnly={enVistaPrevia}
        />
      )}
      {activeTab === "recetas" && (
        <RecetasPaciente
          recetas={recetas}
          onVerReceta={handleDobleClickReceta}
        />
      )}
      {mostrarModal && (
        <ModalEditarPaciente
            paciente={paciente}
            nom024={medico?.perfil?.nom024 ?? false}
            tieneAtencionDesdeActivacionNom={tieneAtencionDesdeActivacionNom}
            onClose={toggleModal}
            onSave={(datosActualizados) => {
            setPaciente(datosActualizados);
            fetchData();
            toggleModal();
            }}
        />
        )}
        {/* 🔹 Modal de Edición de Historia Clínica */}
        {mostrarModalHistoria && (
          <ModalEditarHistoria
            historiaClinica={historiaClinica}
            captureModes={medico?.perfil?.config_cuestionario?.custom?.historia?.capture_modes || {}}
            onClose={toggleModalHistoria}
            onSave={(historiaActualizada) => {
              setHistoriaClinica(historiaActualizada);
              fetchData();
              toggleModalHistoria();
            }}
          />
        )}
        {mostrarModalConsulta && (
          <ModalEditarConsulta
            historiaClinica={historiaClinica}
            onClose={toggleModalConsulta}
            onSave={(historiaActualizada) => {
              setHistoriaClinica(historiaActualizada);
              fetchData();
              toggleModalConsulta();
            }}
          />
        )}

        {mostrarModalImpresion && (
        <ModalImpresionExpediente
          isOpen={mostrarModalImpresion}
          onClose={() => setMostrarModalImpresion(false)}
          consultas={[
            historiaClinica,
            ...(historiaClinica?.consultas || [])
          ]}
          onImprimirCompleto={() => {
            handleImprimirExpediente();
          }}
          onImprimirConsulta={(consulta) => {
            handleImprimirExpediente(consulta);
          }}
        />
      )}


   </main>


    
    </div>
  );
};

export default DashboardPaciente;